
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bHS4c", function(module, exports) {

$parcel$export(module.exports, "HomeActions", () => (parcelRequire("jjK63")).HomeActions);
$parcel$export(module.exports, "AppSwitcher", () => (parcelRequire("eOSTl")).AppSwitcher);
$parcel$export(module.exports, "NavLogo", () => (parcelRequire("dZUTc")).NavLogo);
$parcel$export(module.exports, "CommonActions", () => (parcelRequire("eDezy")).CommonActions);
$parcel$export(module.exports, "Search", () => (parcelRequire("7SLxZ")).Search);
$parcel$export(module.exports, "ChatButton", () => (parcelRequire("50Z6s")).ChatButton);
$parcel$export(module.exports, "UserActions", () => (parcelRequire("b7AUB")).UserActions);
$parcel$export(module.exports, "UserAction", () => (parcelRequire("lXg1y")).UserAction);
$parcel$export(module.exports, "Notifications", () => (parcelRequire("eBhbk")).Notifications);
$parcel$export(module.exports, "CreateButton", () => (parcelRequire("hSQ4A")).CreateButton);
$parcel$export(module.exports, "Help", () => (parcelRequire("brjI4")).Help);
$parcel$export(module.exports, "Profile", () => (parcelRequire("59J9B")).Profile);
$parcel$export(module.exports, "Settings", () => (parcelRequire("6wzBy")).Settings);
$parcel$export(module.exports, "LogIn", () => (parcelRequire("r2Ndy")).LogIn);
$parcel$export(module.exports, "CustomTitle", () => (parcelRequire("9hcDL")).CustomTitle);
$parcel$export(module.exports, "MenuListItem", () => (parcelRequire("jjpBv")).MenuListItem);

var $jjK63 = parcelRequire("jjK63");

var $eOSTl = parcelRequire("eOSTl");

var $dZUTc = parcelRequire("dZUTc");

var $eDezy = parcelRequire("eDezy");

var $7SLxZ = parcelRequire("7SLxZ");

var $50Z6s = parcelRequire("50Z6s");

var $b7AUB = parcelRequire("b7AUB");

var $lXg1y = parcelRequire("lXg1y");

var $eBhbk = parcelRequire("eBhbk");

var $hSQ4A = parcelRequire("hSQ4A");

var $brjI4 = parcelRequire("brjI4");

var $59J9B = parcelRequire("59J9B");

var $6wzBy = parcelRequire("6wzBy");

var $r2Ndy = parcelRequire("r2Ndy");

var $9hcDL = parcelRequire("9hcDL");

var $jjpBv = parcelRequire("jjpBv");

});
parcelRegister("7SLxZ", function(module, exports) {

$parcel$export(module.exports, "Search", () => $2645b4eda592397c$export$4b85d3515bd863a5);
/* search.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $jluld = parcelRequire("jluld");

var $fVUfS = parcelRequire("fVUfS");
var $eoZFI = parcelRequire("eoZFI");
var $iXCQx = parcelRequire("iXCQx");

var $i6ukv = parcelRequire("i6ukv");
const $2645b4eda592397c$var$styles = {
    root: "_2rkoiti9 _1rjcze3t _18zr12x7 _yv0e1mfv _4cvr1h6o _bfhk1j9a _vchhusvi _80om1kdv _1e0cglyw _4t3izwfg _p12f1kvu _1bsb1osq _irr31d5g _1di6r01l _114b11p5",
    buttonText: "_yyhyjvu9 _1ii7kb7n",
    iconBefore: "_yyhykb7n _1ii7kb7n _1e0c1txw",
    elemAfter: "_yyhy11wp _1ii7kb7n _1e0c1txw"
}; /**
    * __Search__
    *
    * The search element for the top navigation.
    */ 
const $2645b4eda592397c$export$4b85d3515bd863a5 = ({ label: label, onClick: onClick, iconBefore: IconBefore = (0, (/*@__PURE__*/$parcel$interopDefault($jluld))), elemAfter: elemAfter, interactionName: interactionName })=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $fVUfS.default), {
                style: {
                    // To win the specificity war against Emotion we move this into inline styles
                    // When Emotion has been stripped from the Design System move this to Compiled.
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    cursor: 'text',
                    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-input, #8590A2)"}`
                },
                onClick: onClick,
                xcss: $2645b4eda592397c$var$styles.root,
                interactionName: interactionName,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                        className: (0, $35pXk.default)([
                            $2645b4eda592397c$var$styles.iconBefore
                        ]),
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)(IconBefore, {
                            color: "var(--ds-icon-subtle, #626F86)",
                            spacing: "spacious",
                            label: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                        className: (0, $35pXk.default)([
                            $2645b4eda592397c$var$styles.buttonText
                        ]),
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                            color: "color.text.subtlest",
                            children: label
                        })
                    }),
                    elemAfter && /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                        className: (0, $35pXk.default)([
                            $2645b4eda592397c$var$styles.elemAfter
                        ]),
                        children: elemAfter
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eoZFI.Show), {
                below: "xs",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $i6ukv.IconButton), {
                    label: label,
                    appearance: "subtle",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($jluld))),
                    onClick: onClick,
                    interactionName: interactionName
                })
            })
        ]
    });

});
parcelRegister("eoZFI", function(module, exports) {

$parcel$export(module.exports, "Show", () => $90d48fa2203af19d$export$f6a3d19be20f5819);
/* show.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $90d48fa2203af19d$var$styles = {
    default: "_1e0cglyw",
    'above.xs': "_114b19ly",
    'above.sm': "_181n19ly",
    'above.md': "_dm2519ly",
    'above.lg': "_je3o19ly",
    'above.xl': "_1uxv19ly",
    'below.xs': "_1m0a19ly",
    'below.sm': "_suga19ly",
    'below.md': "_1mjb19ly",
    'below.lg': "_liwc19ly",
    'below.xl': "_14wz19ly"
};
const $90d48fa2203af19d$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)(AsElement, {
        className: (0, $35pXk.default)([
            $90d48fa2203af19d$var$styles.default,
            above && $90d48fa2203af19d$var$styles[`above.${above}`],
            below && $90d48fa2203af19d$var$styles[`below.${below}`],
            xcss
        ]),
        children: children
    });
};

});

parcelRegister("i6ukv", function(module, exports) {

$parcel$export(module.exports, "IconButton", () => $5ebadc46c5c7a678$export$c25acd513dcc8062);
$parcel$export(module.exports, "LinkIconButton", () => $5ebadc46c5c7a678$export$edad7fca51b767e1);
$parcel$export(module.exports, "Button", () => $5ebadc46c5c7a678$export$353f5b6fc5456de1);
$parcel$export(module.exports, "LinkButton", () => $5ebadc46c5c7a678$export$29d11c0fe2fc51d8);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $ccHMk = parcelRequire("ccHMk");
var $1qfLF = parcelRequire("1qfLF");
var $7p4As = parcelRequire("7p4As");
var $dE1p6 = parcelRequire("dE1p6");

var $lNB6j = parcelRequire("lNB6j");

var $4QwsP = parcelRequire("4QwsP");
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
const $5ebadc46c5c7a678$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $4QwsP.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $lNB6j.ThemedIconButton) : (0, $1qfLF.default);
    return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
        ref: ref,
        ...props
    });
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
const $5ebadc46c5c7a678$export$edad7fca51b767e1 = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $4QwsP.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $lNB6j.ThemedLinkIconButton) : (0, $dE1p6.default);
    return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
        ref: ref,
        ...props
    });
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
const $5ebadc46c5c7a678$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $4QwsP.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $lNB6j.ThemedButton) : (0, $ccHMk.default);
    return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
        ref: ref,
        ...props
    });
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
const $5ebadc46c5c7a678$export$29d11c0fe2fc51d8 = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $4QwsP.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $lNB6j.ThemedLinkButton) : (0, $7p4As.default);
    return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
        ref: ref,
        ...props
    });
});

});
parcelRegister("lNB6j", function(module, exports) {

$parcel$export(module.exports, "themedButtonBackground", () => $c8ddf36f372b1a3e$export$b93b81aa41a8061a);
$parcel$export(module.exports, "themedButtonBackgroundHovered", () => $c8ddf36f372b1a3e$export$96a2312c81489aa1);
$parcel$export(module.exports, "themedButtonBackgroundPressed", () => $c8ddf36f372b1a3e$export$9db7a918ddfed23e);
$parcel$export(module.exports, "themedButtonBorder", () => $c8ddf36f372b1a3e$export$2b00bded80635cbb);
$parcel$export(module.exports, "themedButtonPrimaryText", () => $c8ddf36f372b1a3e$export$eca746d7c1a9cd6e);
$parcel$export(module.exports, "themedButtonPrimaryBackground", () => $c8ddf36f372b1a3e$export$2c2bc298cddb8aca);
$parcel$export(module.exports, "themedButtonPrimaryBackgroundHovered", () => $c8ddf36f372b1a3e$export$6b28e650669cd3c7);
$parcel$export(module.exports, "themedButtonPrimaryBackgroundPressed", () => $c8ddf36f372b1a3e$export$1656be06aad539b9);
$parcel$export(module.exports, "themedButtonSelectedText", () => $c8ddf36f372b1a3e$export$c26a897d419ef487);
$parcel$export(module.exports, "themedButtonSelectedBackground", () => $c8ddf36f372b1a3e$export$4e50e625ccffdb13);
$parcel$export(module.exports, "themedButtonSelectedBackgroundHovered", () => $c8ddf36f372b1a3e$export$55c84c90f36bda4d);
$parcel$export(module.exports, "themedButtonSelectedBackgroundPressed", () => $c8ddf36f372b1a3e$export$c5c0213472126c08);
$parcel$export(module.exports, "themedButtonSelectedBorder", () => $c8ddf36f372b1a3e$export$22928007ff541429);
$parcel$export(module.exports, "themedButtonDisabledText", () => $c8ddf36f372b1a3e$export$787ad93d0f2276af);
$parcel$export(module.exports, "themedButtonDisabledBackground", () => $c8ddf36f372b1a3e$export$5e774f44b77335d6);
$parcel$export(module.exports, "ThemedButton", () => $c8ddf36f372b1a3e$export$f67fb575035cc7d0);
$parcel$export(module.exports, "ThemedLinkButton", () => $c8ddf36f372b1a3e$export$b0b5aeed52623827);
$parcel$export(module.exports, "ThemedIconButton", () => $c8ddf36f372b1a3e$export$d9c2d067feb61447);
$parcel$export(module.exports, "ThemedLinkIconButton", () => $c8ddf36f372b1a3e$export$a1ab08e79d264ec8);
/* button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $ddbVR = parcelRequire("ddbVR");

var $3654r = parcelRequire("3654r");

var $auNCB = parcelRequire("auNCB");
var $fVUfS = parcelRequire("fVUfS");

var $3gadb = parcelRequire("3gadb");

var $6F6hl = parcelRequire("6F6hl");

var $9vHyP = parcelRequire("9vHyP");
function $c8ddf36f372b1a3e$var$getPrimitiveSpreadProps({ style: style, xcss: xcss, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, ...props }) {
    return props;
} /**
   * Props present in underlying primitives but we want to override,
   * so we don't want to inherit their definitions
   */ 
const $c8ddf36f372b1a3e$export$b93b81aa41a8061a = '--ds-top-bar-button-background';
const $c8ddf36f372b1a3e$export$96a2312c81489aa1 = '--ds-top-bar-button-background-hovered';
const $c8ddf36f372b1a3e$export$9db7a918ddfed23e = '--ds-top-bar-button-background-pressed';
const $c8ddf36f372b1a3e$export$2b00bded80635cbb = '--ds-top-bar-button-border';
const $c8ddf36f372b1a3e$export$eca746d7c1a9cd6e = '--ds-top-bar-button-primary-text';
const $c8ddf36f372b1a3e$export$2c2bc298cddb8aca = '--ds-top-bar-button-primary-background';
const $c8ddf36f372b1a3e$export$6b28e650669cd3c7 = '--ds-top-bar-button-primary-background-hovered';
const $c8ddf36f372b1a3e$export$1656be06aad539b9 = '--ds-top-bar-button-primary-background-pressed';
const $c8ddf36f372b1a3e$export$c26a897d419ef487 = '--ds-top-bar-button-selected-text';
const $c8ddf36f372b1a3e$export$4e50e625ccffdb13 = '--ds-top-bar-button-selected-background';
const $c8ddf36f372b1a3e$export$55c84c90f36bda4d = '--ds-top-bar-button-selected-background-hovered';
const $c8ddf36f372b1a3e$export$c5c0213472126c08 = '--ds-top-bar-button-selected-background-pressed';
const $c8ddf36f372b1a3e$export$22928007ff541429 = '--ds-top-bar-button-selected-border';
const $c8ddf36f372b1a3e$export$787ad93d0f2276af = '--ds-top-bar-button-disabled-text';
const $c8ddf36f372b1a3e$export$5e774f44b77335d6 = '--ds-top-bar-button-disabled-background';
const $c8ddf36f372b1a3e$var$styles = {
    root: "_zulp12x7 _11c82smr _2rkosqtm _v5649dqc _4bfu18uv _1hmsglyw _ajmmnqa1 _1rjcze3t _1e0c1txw _4cvr1h6o _1bah1h6o _4t3i5r7u _kqswh2mm _1nrm18uv _1a3b18uv _9oik18uv _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1",
    border: "_14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _aetrb3bt _18postnw",
    selected: "_11q71qds _syazw5ct _8l3m15jn _f8pjw5ct _1053w5ct _19lcjrv1 _30l3w5ct _j6xtnh62 _9h8hw5ct",
    disabled: "_11q71c9b _syaz1i3i _8l3m3acm _f8pj1i3i _10531i3i _19lc1c9b _30l31i3i _j6xt1c9b _9h8h1i3i"
};
const $c8ddf36f372b1a3e$var$shapeStyles = {
    default: "_18zrutpp",
    square: "_18zrze3t _1bsb5r7u _vwz4idpf"
};
const $c8ddf36f372b1a3e$var$appearanceStyles = {
    default: "_11q7pkxg _syaz1r31 _8l3maykr _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    subtle: "_11q7pkxg _syaz1r31 _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    primary: "_11q7esko _syaz15o7 _f8pj15o7 _105315o7 _19lcp6hf _30l315o7 _j6xt5sko _9h8h15o7"
}; /**
    * Props shared by `ThemedPressable` and `ThemedAnchor`
    */ 
const $c8ddf36f372b1a3e$var$ThemedPressable = /*#__PURE__*/ (0, $gwFzn.forwardRef)(function ThemedPressable({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref) {
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fVUfS.default), {
        ...$c8ddf36f372b1a3e$var$getPrimitiveSpreadProps(props),
        ref: ref,
        type: "button" /**
                                                                                 * We are using some style values that are outside of the strict
                                                                                 * `@atlaskit/css` types.
                                                                                 */ ,
        // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $ddbVR.cx)($c8ddf36f372b1a3e$var$styles.root, $c8ddf36f372b1a3e$var$shapeStyles[shape], hasBorder && $c8ddf36f372b1a3e$var$styles.border, $c8ddf36f372b1a3e$var$appearanceStyles[appearance], isSelected && $c8ddf36f372b1a3e$var$styles.selected, isDisabled && $c8ddf36f372b1a3e$var$styles.disabled),
        isDisabled: isDisabled
    });
});
const $c8ddf36f372b1a3e$var$ThemedAnchor = (0, $9vHyP.forwardRefWithGeneric)(function ThemedAnchor({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref) {
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $auNCB.default), {
        ...$c8ddf36f372b1a3e$var$getPrimitiveSpreadProps(props),
        ref: ref,
        // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $ddbVR.cx)($c8ddf36f372b1a3e$var$styles.root, $c8ddf36f372b1a3e$var$shapeStyles[shape], hasBorder && $c8ddf36f372b1a3e$var$styles.border, $c8ddf36f372b1a3e$var$appearanceStyles[appearance], isSelected && $c8ddf36f372b1a3e$var$styles.selected, isDisabled && $c8ddf36f372b1a3e$var$styles.disabled)
    });
});
const $c8ddf36f372b1a3e$var$textButtonStyles = {
    iconBefore: "_vwz4idpf",
    text: "_k48p1wq8"
}; /**
    * Props shared by `Button` and `LinkButton`
    */ 
const $c8ddf36f372b1a3e$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(function ThemedButton({ iconBefore: IconBefore, children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, $7UHDa.jsxs)($c8ddf36f372b1a3e$var$ThemedPressable, {
        ...props,
        ref: ref,
        children: [
            IconBefore && /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                className: (0, $35pXk.default)([
                    $c8ddf36f372b1a3e$var$textButtonStyles.iconBefore
                ]),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)(IconBefore, {
                    label: "",
                    color: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                className: (0, $35pXk.default)([
                    $c8ddf36f372b1a3e$var$textButtonStyles.text
                ]),
                children: children
            })
        ]
    });
});
const $c8ddf36f372b1a3e$export$b0b5aeed52623827 = (0, $9vHyP.forwardRefWithGeneric)(function ThemedLinkButton({ iconBefore: IconBefore, children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, $7UHDa.jsxs)($c8ddf36f372b1a3e$var$ThemedAnchor, {
        ...props,
        ref: ref,
        children: [
            IconBefore && /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                className: (0, $35pXk.default)([
                    $c8ddf36f372b1a3e$var$textButtonStyles.iconBefore
                ]),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)(IconBefore, {
                    label: "",
                    color: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                className: (0, $35pXk.default)([
                    $c8ddf36f372b1a3e$var$textButtonStyles.text
                ]),
                children: children
            })
        ]
    });
}); /**
     * Props shared by `ThemedIconButtonProps` and `ThemedLinkIconButton`
     */ 
const $c8ddf36f372b1a3e$export$d9c2d067feb61447 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(function ThemedIconButton({ icon: Icon, label: label, tooltip: tooltip, ...props }, ref) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
        ...tooltip,
        content: tooltip?.content ?? label,
        children: (triggerProps)=>/**
     * The `aria-describedby` from `triggerProps` is intentionally not passed down,
     * because it would cause double announcements with the `VisuallyHidden` label.
     *
     * The `@atlaskit/button` IconButton uses the same approach.
     */ /*#__PURE__*/ (0, $7UHDa.jsxs)($c8ddf36f372b1a3e$var$ThemedPressable, {
                ...props,
                shape: "square",
                ref: (0, $3654r.default)([
                    ref,
                    triggerProps.ref
                ]),
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    props.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    props.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    props.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    props.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    props.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    props.onBlur?.(e);
                },
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)(Icon, {
                        label: "",
                        color: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6F6hl.default), {
                        children: label
                    })
                ]
            })
    });
});
const $c8ddf36f372b1a3e$export$a1ab08e79d264ec8 = (0, $9vHyP.forwardRefWithGeneric)(function ThemedLinkIconButton({ icon: Icon, label: label, tooltip: tooltip, ...props }, ref) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
        ...tooltip,
        content: tooltip?.content ?? label,
        children: (triggerProps)=>/**
     * The `aria-describedby` from `triggerProps` is intentionally not passed down,
     * because it would cause double announcements with the `VisuallyHidden` label.
     *
     * The `@atlaskit/button` IconButton uses the same approach.
     */ /*#__PURE__*/ (0, $7UHDa.jsxs)($c8ddf36f372b1a3e$var$ThemedAnchor, {
                ...props,
                shape: "square",
                ref: (0, $3654r.default)([
                    ref,
                    triggerProps.ref
                ]),
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    props.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    props.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    props.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    props.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    props.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    props.onBlur?.(e);
                },
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)(Icon, {
                        label: "",
                        color: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6F6hl.default), {
                        children: label
                    })
                ]
            })
    });
});

});

parcelRegister("4QwsP", function(module, exports) {

$parcel$export(module.exports, "HasCustomThemeContext", () => $39cad3631a9b224a$export$d158fa15757a1890);
$parcel$export(module.exports, "useHasCustomTheme", () => $39cad3631a9b224a$export$abfcaeeca4ae7a55);

var $gwFzn = parcelRequire("gwFzn");
const $39cad3631a9b224a$export$d158fa15757a1890 = /*#__PURE__*/ (0, $gwFzn.createContext)(false);
function $39cad3631a9b224a$export$abfcaeeca4ae7a55() {
    return (0, $gwFzn.useContext)($39cad3631a9b224a$export$d158fa15757a1890);
}

});



parcelRegister("50Z6s", function(module, exports) {

$parcel$export(module.exports, "ChatButton", () => $ef8d031d8b585464$export$af9dc48491a7451d);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $lDwiy = parcelRequire("lDwiy");

var $dukN8 = parcelRequire("dukN8");

var $i6ukv = parcelRequire("i6ukv");
const $ef8d031d8b585464$export$af9dc48491a7451d = ({ children: children, onClick: onClick, isSelected: isSelected, interactionName: interactionName })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $dukN8.ListItem), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $i6ukv.Button), {
            appearance: "default",
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($lDwiy))),
            onClick: onClick,
            isSelected: isSelected,
            interactionName: interactionName,
            children: children
        })
    });

});

parcelRegister("hSQ4A", function(module, exports) {

$parcel$export(module.exports, "CreateButton", () => $9e9a1cfed922fb9c$export$6d3c345ce7c38fd9);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $g5gZt = parcelRequire("g5gZt");

var $i6ukv = parcelRequire("i6ukv");
const $9e9a1cfed922fb9c$export$6d3c345ce7c38fd9 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ children: children, onClick: onClick, testId: testId, interactionName: interactionName }, ref)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $i6ukv.Button), {
        ref: ref,
        appearance: "primary",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))),
        onClick: onClick,
        testId: testId,
        interactionName: interactionName,
        children: children
    }));

});

parcelRegister("brjI4", function(module, exports) {

$parcel$export(module.exports, "Help", () => $013d30bc1c29b80b$export$1be7516c0280bee8);
/**
 * @jsxRuntime classic
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $ci7Ox = parcelRequire("ci7Ox");

var $2uMjy = parcelRequire("2uMjy");

var $lXg1y = parcelRequire("lXg1y");
const $013d30bc1c29b80b$var$HELP_NOTIFICATION_BADGE_ID = 'atlassian-navigation-help-notification-count';
const $013d30bc1c29b80b$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(function Help({ label: label, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, isListItem: isListItem, badge: badge }, ref) {
    const sharedProps = {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))),
        label: label,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        isSelected: isSelected,
        testId: testId,
        interactionName: interactionName,
        ref: ref
    };
    if (!badge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lXg1y.UserAction), {
        ...sharedProps,
        isListItem: isListItem
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2uMjy.BadgeContainer), {
        id: $013d30bc1c29b80b$var$HELP_NOTIFICATION_BADGE_ID,
        badge: badge,
        // We only need to set the list item role on the top level element (BadgeContainer)
        isListItem: isListItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lXg1y.UserAction), {
        ...sharedProps,
        // We explicitly set the UserAction to not be a list item,
        // because the BadgeContainer already has a list item role (if `isListItem` is true)
        isListItem: false
    }));
});

});

parcelRegister("59J9B", function(module, exports) {

$parcel$export(module.exports, "Profile", () => $efd33a1352caab6a$export$5120f2d0b8d4cab8);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $esRft = parcelRequire("esRft");

var $lXg1y = parcelRequire("lXg1y");
const $efd33a1352caab6a$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ src: src, ...props }, ref)=>{
    const ProfileAvatar = (0, $gwFzn.useCallback)(()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $esRft.default), {
            appearance: "circle",
            src: src,
            size: "small"
        }), [
        src
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lXg1y.UserAction), {
        ...props,
        ref: ref,
        icon: ProfileAvatar
    });
});

});

parcelRegister("6wzBy", function(module, exports) {

$parcel$export(module.exports, "Settings", () => $217f9e21be543824$export$c72f6eaae7b9adff);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $fIcbd = parcelRequire("fIcbd");

var $lXg1y = parcelRequire("lXg1y");
const $217f9e21be543824$export$c72f6eaae7b9adff = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $lXg1y.UserAction), {
        ...props,
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fIcbd)))
    }));

});

parcelRegister("r2Ndy", function(module, exports) {

$parcel$export(module.exports, "LogIn", () => $73793e33d62b561c$export$88195aaac9f90319);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $ilSNM = parcelRequire("ilSNM");

var $dukN8 = parcelRequire("dukN8");

var $i6ukv = parcelRequire("i6ukv");
const $73793e33d62b561c$export$88195aaac9f90319 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ onClick: onClick, onMouseEnter: onMouseEnter, testId: testId, interactionName: interactionName, href: href, label: label }, ref)=>/**
		 * This component doesn't use `UserAction` internally because it renders a
		 * `LinkIconButton` instead of an `IconButton`.
		 *
		 * We could make another abstraction, but this is the only top navigation item
		 * that renders a link.
		 */ /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dukN8.ListItem), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $i6ukv.LinkIconButton), {
            ref: ref,
            label: label,
            href: href,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            testId: testId,
            interactionName: interactionName,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ilSNM))),
            appearance: "subtle",
            isTooltipDisabled: false
        })
    }));

});
parcelRegister("ilSNM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cd6da84e11aa1d5b6e9ca710faf282a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d5c4b2a6e8ca72fd$var$_react = $d5c4b2a6e8ca72fd$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $d5c4b2a6e8ca72fd$var$_baseNew = $d5c4b2a6e8ca72fd$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $d5c4b2a6e8ca72fd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogIn".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for log in.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d5c4b2a6e8ca72fd$var$LogInIcon = (props)=>/*#__PURE__*/ $d5c4b2a6e8ca72fd$var$_react.default.createElement($d5c4b2a6e8ca72fd$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 2.5H8V1h5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8v-1.5h5a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5M7.44 7.25 5.22 5.03l1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$d5c4b2a6e8ca72fd$var$LogInIcon.displayName = 'LogInIcon';
var $d5c4b2a6e8ca72fd$var$_default = module.exports.default = $d5c4b2a6e8ca72fd$var$LogInIcon;

});


parcelRegister("9hcDL", function(module, exports) {

$parcel$export(module.exports, "CustomTitle", () => $d59c3818b0797f2f$export$9ccddf7ee2a0e24e);
/* custom-title.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dh538 = parcelRequire("dh538");

var $4QwsP = parcelRequire("4QwsP");
const $d59c3818b0797f2f$var$styles = {
    root: "_1reo15vq _18m915vq _11c82smr _o5721q9c _p12fuuw1 _1bto1l2s _bozg1b66 _1e0cglyw _10y41txw",
    subtleText: "_syaz1gjq",
    paddingInlineEnd: "_y4tiu2gc"
};
const $d59c3818b0797f2f$export$9ccddf7ee2a0e24e = /*#__PURE__*/ (0, $gwFzn.forwardRef)(function CustomTitle({ children: children, testId: testId }, ref) {
    const hasCustomTheme = (0, $4QwsP.useHasCustomTheme)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        ref: ref,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            $d59c3818b0797f2f$var$styles.root,
            !hasCustomTheme && $d59c3818b0797f2f$var$styles.subtleText,
            (0, $dh538.fg)('platform_design_system_nav4_top_nav_min_widths') && $d59c3818b0797f2f$var$styles.paddingInlineEnd
        ]),
        children: children
    });
});

});


parcelRegister("kNHXO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a710c2ad5ea3773aa39998727af6369>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f24a7c82f1a8c849$var$_react = $f24a7c82f1a8c849$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $f24a7c82f1a8c849$var$_baseNew = $f24a7c82f1a8c849$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f24a7c82f1a8c849$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AppSwitcher".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for app switcher in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f24a7c82f1a8c849$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $f24a7c82f1a8c849$var$_react.default.createElement($f24a7c82f1a8c849$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM9 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM1 11a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zm6 .5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$f24a7c82f1a8c849$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
var $f24a7c82f1a8c849$var$_default = module.exports.default = $f24a7c82f1a8c849$var$AppSwitcherIcon;

});

parcelRegister("bNwbD", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", () => $95c4b21f9fd4bea1$export$e5c5a5f917a5871c);

var $gwFzn = parcelRequire("gwFzn");
const $95c4b21f9fd4bea1$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $gwFzn.useEffect) : (0, $gwFzn.useLayoutEffect);

});

parcelRegister("dM2NO", function(module, exports) {

$parcel$export(module.exports, "List", () => $4e2cb6c2515ba804$export$54c2e3dc7acea9f5);
/* list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
function $4e2cb6c2515ba804$var$_List({ children: children, testId: testId, xcss: xcss }, forwardedRef) {
    return(/**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        role: "list",
        ref: forwardedRef,
        className: xcss,
        "data-testid": testId,
        children: children
    }));
}
const $4e2cb6c2515ba804$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $gwFzn.forwardRef)($4e2cb6c2515ba804$var$_List);

});

parcelRegister("ckcSY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1e0c080c29498771abac7d6e0a3c394>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8f91591f413eb2d9$var$_react = $8f91591f413eb2d9$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $8f91591f413eb2d9$var$_baseNew = $8f91591f413eb2d9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8f91591f413eb2d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notification".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for notifications within global product navigation and within product screens.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8f91591f413eb2d9$var$NotificationIcon = (props)=>/*#__PURE__*/ $8f91591f413eb2d9$var$_react.default.createElement($8f91591f413eb2d9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 5a5 5 0 0 1 10 0v3.535l1.788 2.861a1.375 1.375 0 0 1-1.166 2.104h-2.459a3.251 3.251 0 0 1-6.326 0h-2.46a1.375 1.375 0 0 1-1.165-2.104L3 8.535zm3.418 8.5a1.75 1.75 0 0 0 3.164 0zM8 1.5A3.5 3.5 0 0 0 4.5 5v3.636c0 .215-.06.426-.175.608L2.603 12h10.794l-1.723-2.756a1.15 1.15 0 0 1-.174-.608V5A3.5 3.5 0 0 0 8 1.5" clip-rule="evenodd"/>`
    }, props));
$8f91591f413eb2d9$var$NotificationIcon.displayName = 'NotificationIcon';
var $8f91591f413eb2d9$var$_default = module.exports.default = $8f91591f413eb2d9$var$NotificationIcon;

});


//# sourceMappingURL=top-nav.5a6babce.js.map
